import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { storage } from './config';

export const uploadProductImage = async (file: File): Promise<string> => {
  const auth = getAuth();
  if (!auth.currentUser) {
    throw new Error('Usuario no autenticado');
  }

  try {
    const timestamp = Date.now();
    const storageRef = ref(storage, `products/${timestamp}_${file.name}`);
    
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return downloadURL;
  } catch (error) {
    console.error('Error al subir la imagen:', error);
    throw error;
  }
}

export const uploadSiteImage = async (file: File): Promise<string> => {
  const auth = getAuth();
  if (!auth.currentUser) {
    throw new Error('Usuario no autenticado');
  }

  try {
    const timestamp = Date.now();
    // Using products folder as it likely has write permissions if site/ doesn't
    const storageRef = ref(storage, `products/hero_${timestamp}_${file.name}`);
    
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return downloadURL;
  } catch (error) {
    console.error('Error al subir la imagen del sitio:', error);
    throw error;
  }
}

export const deleteProductImage = async (imageUrl: string) => {
  try {
    const imageRef = ref(storage, imageUrl);
    await deleteObject(imageRef);
  } catch (error) {
    console.error('Error al eliminar la imagen:', error);
    throw error;
  }
}
